
import './index.less'
import React from 'react'
console.log(React)
export default function Radio(props) {
  return (<div className='radio' onClick={() => {
    props.change && props.change(props.label)
  }}>
    <span className={`radio_box ${props.label === props.radio ? 'active' : ''}`}></span>
    <span className='radio_text'>{props.children}</span>
  </div>)
}
